function normalizeKeys(keys) {
    // Keep iterator materialization explicit for the microbundle-crl Web build.
    return Array.from(
        new Set((keys instanceof Array ? keys : [keys]).map((key) => String(key || '').trim()).filter(Boolean))
    );
}

// Coordinates socket patches with overlapping targeted/full reconciliation
// requests. A response is allowed to mutate the UI only while the entities it
// was requested for still have the same revision.
export default function createAntLiveRefreshCoordinator() {
    let revision = 0;
    let globalRevision = 0;
    const entityRevisions = new Map();

    const mark = (keys = []) => {
        const normalizedKeys = normalizeKeys(keys);
        revision += 1;
        if (normalizedKeys.length === 0) globalRevision = revision;
        else normalizedKeys.forEach((key) => entityRevisions.set(key, revision));
        return revision;
    };

    const capture = (keys = []) => {
        const normalizedKeys = normalizeKeys(keys);
        const capturedEntityRevisions = {};
        normalizedKeys.forEach((key) => {
            capturedEntityRevisions[key] = entityRevisions.get(key) || 0;
        });
        return {
            revision,
            globalRevision,
            keys: normalizedKeys,
            entityRevisions: capturedEntityRevisions
        };
    };

    const isCurrent = (token, key) => {
        if (!token) return false;
        if (key !== undefined && key !== null) {
            const normalizedKey = String(key).trim();
            return (
                token.globalRevision === globalRevision &&
                (token.entityRevisions?.[normalizedKey] || 0) === (entityRevisions.get(normalizedKey) || 0)
            );
        }
        if (token.keys?.length > 0) return token.keys.every((entityKey) => isCurrent(token, entityKey));
        return token.revision === revision;
    };

    const filterCurrent = (token, rows, getIdentity) => {
        if (!(rows instanceof Array)) return [];
        const resolveIdentity = typeof getIdentity === 'function' ? getIdentity : (row) => row?.id;
        return rows.filter((row) => isCurrent(token, resolveIdentity(row)));
    };

    return { mark, capture, isCurrent, filterCurrent };
}
